import { ref, onMounted, onUnmounted, isRef, watch } from 'vue'

const NAVBAR_HEIGHT = 58

export function useEducationToc(sectionIds) {
  const getIds = () => {
    return isRef(sectionIds) ? sectionIds.value : sectionIds
  }

  const activeId = ref(getIds()?.[0])
  const isExpanded = ref(false)

  if (isRef(sectionIds)) {
    watch(sectionIds, (newIds) => {
      if (newIds && newIds.length > 0 && !activeId.value) {
        activeId.value = newIds[0]
      }
    }, { immediate: true })
  }

  function scrollToSection(id) {
    const el = document.getElementById(id)
    if (!el) return
    const extra = window.innerWidth <= 960 ? 110 : 40
    const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT - extra
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
  }

  function toggleExpand() {
    isExpanded.value = !isExpanded.value
  }

  function collapseAndScroll(id) {
    isExpanded.value = false
    scrollToSection(id)
  }

  let removeListener = null

  onMounted(() => {
    const update = () => {
      const ids = getIds()
      if (!ids || ids.length === 0) return
      const threshold = window.scrollY + NAVBAR_HEIGHT + 130
      let current = ids[0]
      for (const id of ids) {
        const el = document.getElementById(id)
        if (el && el.offsetTop <= threshold) current = id
      }
      activeId.value = current
    }

    window.addEventListener('scroll', update, { passive: true })
    update()
    removeListener = () => window.removeEventListener('scroll', update)
  })

  onUnmounted(() => {
    if (removeListener) removeListener()
  })

  return { activeId, isExpanded, scrollToSection, toggleExpand, collapseAndScroll }
}

